import http from 'plugins/axios'

export default {
  //获取交易对列表
  getSymbolList() {
    return http.get({
      url: '/ta/admin/tenant/symbol/getSymbolList',
      data: { type: 'CONTRACT' },
    })
  },

  //获取币种列表
  getCoinList() {
    return http.get({
      url: '/channel/common/coinList',
    })
  },
  getHistory(params) {
    return http.get({
      url: '/ta/admin/tenant/activity/user/record/list',
      params,
    })
  },
  exportExcel(params) {
    return http.get({
      url: '/ta/admin/channel/position/listLog/excel',
      params,
      responseType: 'blob',
    })
  },
  getHistoryInfo(params) {
    return http.get({
      url: '/ta/admin/channel/position/listLogTotalInfo',
      params,
    })
  },
  delPositionId(positionId) {
    return http.post({
      url: `/ta/admin/channel/position/deleteHistory?positionId=${positionId}`,
    })
  },
}
